import commonStyles from "../commonStyles";
import React, {useState} from "react";
import {useSpring, animated} from "react-spring";
import {easings} from "@react-spring/web";

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

function CardPersona(props) {
    const style = useSpring({ to: { opacity: 1, marginTop: 0 }, from: { opacity: 0, marginTop: -100 }, config: {easing: easings.easeOutBack }})

    const [open, toggle] = useState(false)

    const styles = useSpring({
        opacity: open? 0 : 1,
        marginTop: open? '-250px' : '0',
        config: { duration: 500, easing: easings.easeInBack }
    })

    return(

        <animated.div style={styles}>
        <animated.div style={style}>
            <div className="card shadow-lg p-2 mb-5 bg-body rounded" style={ commonStyles.cardRisultato }>
                <div className="card-body">

                    <div style={{ textAlign: 'center' }}>
                        <h2 className="card-title text-capitalize">{ props.persona.nome }</h2>
                    </div>



                    {props.flag &&
                        <div>
                            <hr />
                            <p className="card-text">Personal Charge:</p>
                            <p>{props.persona.spesaPers}$</p>
                        </div>
                    }

                    <hr />

                    <p className="card-text">Money Given:</p>
                    <p>{ props.persona.spesaTot }$</p>

                    <hr />

                    <button className={"btn btn-danger"} onClick={async () => {
                        toggle(!open)
                        await sleep(500)
                        props.onDelete(props.persona)
                    }}>

                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" fill="currentColor"
                             className="bi bi-trash" viewBox="0 0 16 16">
                            <path
                                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                            <path fill-rule="evenodd"
                                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                        </svg>
                    </button>

                </div>
            </div>
        </animated.div>
        </animated.div>
    );
}

export default CardPersona